import Button from "../../../components/shared/button";
import DarkModeToggle from "../../../components/shared/darkModeToggle";
import { env } from "env";
import React, { PropsWithChildren } from "react";
import { Link } from "react-router";
import { usePopover } from "../../../providers/PopoverProvider";
import ContextMenuList from "../../../components/ContextMenu/ContextMenuList";
import { getAppUrl } from "../../../utils/defines";
import Ripple from "../../../components/Ripple";
import { getKeyUpHandler } from "../../../utils/helpers";

const ProfileDropdown: React.FC = () => {
  return (
    <ContextMenuList
      data-space="5"
      items={[
        { text: `API Help`, link: `${env.api_url}/swagger/index.html` },
        { text: `Template`, link: getAppUrl("template") },
        { separator: true },

        {
          customElement: (
            <li //NOSONAR
              data-type="inert"
              data-radius="5"
              onClick={(e) => { e.stopPropagation() }} onKeyUp={getKeyUpHandler()} //NOSONAR
            >
              <DarkModeToggle />
            </li>
          ),
        },
        { separator: true },
        {
          element: (
            <>
              <icon data-length="30">info</icon>
              <group data-gap="10" data-align="center">
                <text>Version</text>
                <separator data-vertical="" data-height="20"></separator>
                <text data-light="" //NOSONAR
                >{env.version}</text>
              </group>
            </>
          ),
        },
      ]}
    />
  );
};

const Footer: React.FC<PropsWithChildren<unknown>> = () => {
  const { open } = usePopover();
  const footerDropdown = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    open({
      content: <ProfileDropdown />,
      element: e.target as HTMLElement,
    });
  };

  return (
    <group
      data-space-horizontal="20"
      data-index="1"
      data-max-length="1200"
      data-position="center"
    >
      <separator data-horizontal="" data-margin="none"></separator>
      <group
        data-gap="5"
        data-align="center"
        //data-justify="end"
        data-wrap="no"
        data-space="15"
        data-space-horizontal="10"
      >
        <group
          data-wrap="no"
          data-gap="5"
          data-align="center"
          data-width="auto"
        >
          <group
            data-gap="5"
            data-align="center"
            data-width="auto"
            data-adaptive="desktop"
          >
            <Link
              to={`${env.api_url}/swagger/index.html`}
              className="button"
              target="_blank"
            >
              <text>API Help</text>
            </Link>
            <separator data-vertical=""></separator>
            <Link to="template" className="button">
              <text>Template</text>
            </Link>
          </group>

          <Button
            mini
            data-adaptive="mobile"
            icon="apps"
            onClick={footerDropdown}
          ></Button>

          <group data-width="auto" data-gap="10" data-adaptive="desktop">
            <separator data-vertical=""></separator>
            <DarkModeToggle />
          </group>
        </group>

        <group
          data-wrap="no"
          data-position="right"
          data-width="auto"
          data-align="center"
          data-gap="10"
          data-contain=""
        >
          <group
            data-width="auto"
            data-adaptive="desktop"
            data-align="center"
            data-gap="10"
          >
            <text data-space="5" data-space-horizontal="10" data-ellipsis="">
              Version {env.version}
            </text>
            <separator data-vertical=""></separator>
          </group>
          <Ripple>
            <group
              data-width="auto"
              data-interactive=""
              data-radius="5"
              data-space-horizontal="5"
              data-contain=""
            >
              
            </group>
          </Ripple>
        </group>
      </group>
    </group>
  );
};

export default Footer;
